import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import Dashboard from './views/dashboard/Dashboard'
import Sms from './views/sms/Sms'
import SmsNew from './views/sms/SmsNew'
import SmsInfo from './views/sms/SmsInfo'
import Categories from './views/categories/Categories'
import Users from './views/users/Users'
import Cars from './views/cars/Cars'
import NotFound from '../error/NotFound'
import Server500 from '../error/Server500'
import Oil from './views/products/child/Oil'
import Mechanical from './views/products/child/Mechanical'
import CarCategories from './views/cars/child/CarCategories'
import CarInfo from './views/cars/child/CarInfo'
import CarServiceWithDate from './views/service/CarServiceWithDate'
import NewService from './views/service/new/NewService'

function ContentRoutes() {
  const [isErrorPAge, setIsErrorPage] = useState(false)
  let page_name = useSelector((state) => state?.pageNameReducer?.page_name)
  let user_device = useSelector((state) => state?.deviceReducer?.device)

  useEffect(() => {
    async function fetchData() {
      if (page_name === '404' || page_name === '500') {
        setIsErrorPage(true)
      } else {
        setIsErrorPage(false)
      }
    }
    fetchData()
  }, [page_name])

  return (
    <div
      className={
        isErrorPAge
          ? user_device === 'desktop'
            ? 'w-full mx-auto'
            : 'py-6 w-full px-4 mx-auto'
          : user_device === 'desktop'
          ? 'py-6 px-4 xl:w-full xl:max-w-[1460px] xl:mx-auto'
          : 'py-3 px-4 w-full mx-auto'
      }
    >
      <Routes>
        <Route path={'dashboard'} element={<Dashboard />} />
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path={'cars'} element={<Cars />} />
        <Route path={'cars/categories'} element={<CarCategories />} />
        <Route path={'cars/:car_code'} element={<CarInfo />} />
        <Route path={'cars/:car_code/service'} element={<CarServiceWithDate />} />
        <Route path={'products/oil'} element={<Oil />} />
        <Route path={'products/mechanical'} element={<Mechanical />} />
        <Route path="products" element={<Navigate to="products/oil" replace />} />

        <Route path={'service/new'} element={<NewService />} />

        <Route path={'users'} element={<Users />} />
        <Route path={'categories'} element={<Categories />} />
        <Route path={'sms'} element={<Sms />} />
        <Route path={'sms/new'} element={<SmsNew />} />
        <Route path={'sms/:smsId'} element={<SmsInfo />} />
        <Route path={'404'} element={<NotFound />} />
        <Route path={'*'} element={<Navigate to="404" replace />} />
        <Route path={'500'} element={<Server500 />} />
      </Routes>
    </div>
  )
}

export default memo(ContentRoutes)
